export default "__VITE_ASSET__6jYT8Pn5__";